/******/ (function() { // webpackBootstrap
(function () {
  // Store the initial view parameter value if present
  var currentViewParam = new URLSearchParams(window.location.search).get('view');

  // Cache DOM references and constants
  var GIBSON_VIEW = 'gibson';
  var CHECK_INTERVAL = 200; // Increased from 100ms to reduce CPU usage

  // Function to check and restore the view parameter if needed
  var preserveViewParameter = function preserveViewParameter() {
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var newViewParam = urlParams.get('view');

      // Early return if newViewParam is 'gibson'
      if (newViewParam === GIBSON_VIEW || currentViewParam === GIBSON_VIEW) {
        return;
      }

      // If view parameter was present before but is now missing, restore it
      if (currentViewParam && !newViewParam) {
        var url = new URL(window.location.href);
        url.searchParams.set('view', currentViewParam);

        // Update URL without triggering a page reload
        window.history.pushState({}, '', url.toString());
      } else if (newViewParam) {
        // Update our stored view parameter if it changed
        currentViewParam = newViewParam;
      }
    } catch (error) {
      console.error('Error in preserveViewParameter:', error);
    }
  };

  // Use a single reference to the current URL to avoid repeated property access
  var lastHref = window.location.href;

  // Debounced URL change checker
  var checkTimeout = null;
  var checkURLChange = function checkURLChange() {
    var currentHref = window.location.href;
    if (currentHref !== lastHref) {
      preserveViewParameter();
      lastHref = currentHref;
    }
  };

  // Use requestAnimationFrame for better performance than setInterval
  var isChecking = false;
  var _scheduleCheck = function scheduleCheck() {
    if (!isChecking) {
      isChecking = true;
      checkTimeout = setTimeout(function () {
        checkURLChange();
        isChecking = false;
        _scheduleCheck();
      }, CHECK_INTERVAL);
    }
  };

  // Start the checking process
  _scheduleCheck();

  // Clean up resources when page unloads
  window.addEventListener('unload', function () {
    if (checkTimeout) {
      clearTimeout(checkTimeout);
    }
  }, {
    passive: true
  });

  // Listen for popstate events (browser back/forward navigation)
  window.addEventListener('popstate', preserveViewParameter, {
    passive: true
  });

  // Intercept history methods only once
  var originalPushState = history.pushState;
  history.pushState = function () {
    var result = originalPushState.apply(this, arguments);
    try {
      preserveViewParameter();
    } catch (error) {
      console.error('Error in pushState override:', error);
    }
    return result;
  };
  var originalReplaceState = history.replaceState;
  history.replaceState = function () {
    var result = originalReplaceState.apply(this, arguments);
    try {
      preserveViewParameter();
    } catch (error) {
      console.error('Error in replaceState override:', error);
    }
    return result;
  };
})();
/******/ })()
;